import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { useField } from 'formik';

export const CustomSwitch = ({ label, name, checked }: any) => {
  const [field] = useField(name);

  return (
    <FormGroup>
      <FormControlLabel
        label={label}
        checked={checked}
        control={
          <Switch inputProps={{ 'aria-label': 'controlled' }} {...field} />
        }
      />
    </FormGroup>
  );
};
